<!-- ── Encabezado ───────────────────────────────────────────────────────── -->
<app-page-title [title]="pageLabel()" backRoute="/support/menu" backTooltip="Regresar al menú de Soporte"></app-page-title>
<app-page-loader [load]="pageLoad" [label]="pageLabel()" (retry)="init()"></app-page-loader>

@if (loading()) {
  <div class="loading-row">
    <mat-spinner diameter="22"></mat-spinner>
    <span>Cargando manuales…</span>
  </div>
} @else if (roles().length === 0) {

  <!-- Sin rol asignado no hay manual que mostrar. -->
  <div class="empty-state">
    <mat-icon>lock_outline</mat-icon>
    <p class="empty-title">No hay un rol asociado a tu usuario</p>
    <span class="empty-text">
      Pide al responsable del sistema que te asigne un rol para poder ver tu manual.
    </span>
  </div>

} @else {

  <div class="manuals-layout" [class.single-role]="!canEdit()">

    <!-- ── Roles (solo el admin ve la lista completa) ─────────────────── -->
    @if (canEdit()) {
      <aside class="roles-panel">
        <div class="panel-title">
          <mat-icon>badge</mat-icon>
          <span>Roles</span>
        </div>

        <div class="roles-list">
          @for (role of roles(); track role.id) {
            <button class="role-item"
                    [class.selected]="role.id === selectedRoleId()"
                    (click)="selectRole(role.id)">
              <div class="role-main">
                <span class="role-name">{{ role.name }}</span>
                <span class="role-meta">
                  @if (hasPdf(role.id)) {
                    <span class="tag tag-pdf">PDF</span>
                  } @else {
                    <span class="tag tag-empty">Sin PDF</span>
                  }
                  <span class="tag tag-videos">{{ videosFor(role.id) }} video(s)</span>
                </span>
              </div>
              <mat-icon>chevron_right</mat-icon>
            </button>
          }
        </div>
      </aside>
    }

    <!-- ── Contenido del rol seleccionado ─────────────────────────────── -->
    <section class="manual-panel">

      <div class="manual-header">
        <div>
          <h3>{{ selectedRole()?.name }}</h3>
          <span class="manual-subtitle">{{ selectedRole()?.description }}</span>
        </div>
      </div>

      <!-- PDF del manual -->
      <div class="card pdf-card">
        <div class="card-head">
          <mat-icon class="card-icon">picture_as_pdf</mat-icon>
          <div class="card-title">
            <span class="title">Manual en PDF</span>
            <span class="hint">
              @if (selectedManual()?.pdf) {
                {{ selectedManual()?.pdfName || 'Documento cargado' }}
              } @else {
                Todavía no se ha cargado el manual de este rol.
              }
            </span>
          </div>
        </div>

        <div class="card-actions">
          @if (selectedManual()?.pdf) {
            <button mat-raised-button color="accent" (click)="openPdf()">
              <mat-icon>open_in_new</mat-icon>
              Abrir manual
            </button>
          }
          @if (canEdit()) {
            <button mat-stroked-button (click)="uploadPdf()">
              <mat-icon>upload_file</mat-icon>
              {{ selectedManual()?.pdf ? 'Reemplazar' : 'Cargar PDF' }}
            </button>
          }
        </div>
      </div>

      <!-- Videos por módulo -->
      <div class="videos-section">
        <div class="videos-head">
          <div class="card-title">
            <span class="title">Videos por módulo</span>
            <span class="hint">{{ videoCount() }} video(s) en este rol</span>
          </div>
          @if (canEdit()) {
            <button mat-raised-button color="accent" (click)="addVideo()">
              <mat-icon>add</mat-icon>
              Agregar video
            </button>
          }
        </div>

        @if (videoGroups().length === 0) {
          <div class="empty-state small">
            <mat-icon>smart_display</mat-icon>
            <p class="empty-title">Sin videos todavía</p>
            <span class="empty-text">
              @if (canEdit()) {
                Agrega el primer video y asígnalo al módulo que explica.
              } @else {
                Cuando se carguen videos para tu rol, aparecerán aquí.
              }
            </span>
          </div>
        } @else {
          @for (group of videoGroups(); track group.module) {
            <div class="module-group">
              <div class="module-title">
                <mat-icon>folder_open</mat-icon>
                <span>{{ group.module }}</span>
                <span class="module-count">{{ group.videos.length }}</span>
              </div>

              <div class="video-grid">
                @for (video of group.videos; track video.id) {
                  <div class="video-card">
                    <div class="video-main" (click)="openVideo(video)">
                      <mat-icon class="play-icon">play_circle</mat-icon>
                      <div class="video-info">
                        <span class="video-title">{{ video.title }}</span>
                        @if (video.description) {
                          <span class="video-description">{{ video.description }}</span>
                        }
                        <span class="video-file">{{ video.fileName }}</span>
                      </div>
                    </div>

                    @if (canEdit()) {
                      <div class="video-actions">
                        <button mat-icon-button matTooltip="Editar" (click)="editVideo(video)">
                          <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button color="warn" matTooltip="Quitar"
                                (click)="deleteVideo(video)">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
        }
      </div>

    </section>
  </div>
}
